(() => {
  if (customElements.get('navarambh-terms')) return;
  customElements.define('navarambh-terms', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const groups = [...this.querySelectorAll('.nvTerms__item')];
      const button = this.querySelector('.nvTerms__button');
      const sync = () => {
        if (!button) return;
        const expanded = groups.every(group => group.open);
        button.setAttribute('aria-expanded', String(expanded));
        button.querySelector('span').textContent = expanded ? 'Collapse all terms' : 'Expand all terms';
      };
      if (button) {
        button.hidden = false;
        button.addEventListener('click', () => {
          const expanded = !groups.every(group => group.open);
          groups.forEach(group => { group.open = expanded; });
          sync();
        }, options);
      }
      groups.forEach(group => group.addEventListener('toggle', sync, options));
      this.addEventListener('shopify:block:select', event => {
        const group = event.target.closest('.nvTerms__item');
        if (group) { group.open = true; group.classList.add('is-in'); sync(); }
      }, options);
      if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) { entry.target.classList.add('is-in'); this.observer.unobserve(entry.target); }
        });
      }, { threshold: 0.05, rootMargin: '0px 0px 40px 0px' });
      this.querySelectorAll('.nvTerms__reveal').forEach(element => this.observer.observe(element));
      this.classList.add('is-ready');
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); this.classList.remove('is-ready'); }
  });
})();